import { render, staticRenderFns } from "./Inprogress.vue?vue&type=template&id=ed319ec4&scoped=true&"
import script from "./Inprogress.vue?vue&type=script&lang=js&"
export * from "./Inprogress.vue?vue&type=script&lang=js&"
import style0 from "./Inprogress.vue?vue&type=style&index=0&id=ed319ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed319ec4",
  null
  
)

export default component.exports